// react-bootstrap imports
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

// service imports
import { userLogado} from "services/LoginFunctions"

// component imports
import { ButtonVer, TabelaBanco } from "components/Tabela"

// assets imports
import iconPdf from "assets/icon_pdf.png"
import iconEdit from "assets/icon_edit.png"
import iconTrash from "assets/icon_trash.png"

// constant imports
import * as Links from "constants/links"
import { Button } from "react-bootstrap"
import { CustomTooltip } from "components/Helpers"
import { BotaoComModalConfirmacao } from "components/Modals"
import { excluirMulta, BaixarMultaFromID, PegarTodasMultas } from "services/CallAPIs"



const ButtonsMulta = ({ docData, reload }) =>
{
    const btnStyle = "rounded-4 mx-2 my-auto btn btn-primary"
    const btnVariant = "outline-primary"

    const ButtonVerMulta = ({ docData, prevState }) =>
    {
        const disabled = !docData
        return (
            <ButtonVer url={Links.VER_DOCUMENTO} disabled={disabled} state={{docData: docData, statePrevPage: prevState, linkPrevPage: Links.MINHAS_MULTAS}} text={"Ver Documento"} altText={"Botão para visualizar o documento"} />
        )
    }
    
    const ButtonDownloadMulta = ({ docData }) =>
    {        
        async function BaixarDoc()
        {
            await BaixarMultaFromID(docData.id, "Multa", true)
        }
        return (
            <CustomTooltip 
                htmlObj={<Button className={btnStyle} variant={btnVariant} onClick={BaixarDoc}><img src={iconPdf} alt="Botão de baixar pdf" /></Button>} 
                text={"Baixar documento"}
            />
        ) 
    }
    
    const ButtonEditarDocumento = ({ docData, prevState }) =>
    {
        const navigate = useNavigate()
        const enabled = !!docData
    
        function Redirect()
        {
            const urlDestino = Links.GERAR_MULTA
            
            let state = {                
                servicoTaxa:
                {
                    id: docData?.fatoGerador,
                    nome: docData.tipoDoc,
                },
                taxInputs: docData?.detalhesMulta?.taxInputs,
                taxResults: docData.taxas,
                dadosMulta: docData
                
                // editar: true,
                // linkPrevPage: Links.MINHAS_MULTAS,
                // statePrevPage: prevState
            }
    
            navigate(urlDestino, {state: state})
        }
    
        return(
            <CustomTooltip 
                htmlObj={<Button className={btnStyle} variant={btnVariant} onClick={Redirect} disabled={!enabled}><img src={iconEdit} alt="Botão de editar documento" /></Button>} 
                text={"Editar documento"}/>
        ) 
    }    
    
    const ButtonExcluir = ({ docData, reload, enabled }) =>
    {
        const [modalShow, setModalShow] = useState(false);
    
        async function excluir() 
        {
            await excluirMulta(docData.id)
            setModalShow(false)
            reload()
        }

        return(
            <>
                <CustomTooltip 
                    htmlObj={<Button className={btnStyle} variant={btnVariant} onClick={() => setModalShow(true)} disabled={!enabled}><img src={iconTrash} alt="Botão de excluir pdf" /></Button>} 
                    text={"Excluir documento"}/>
                
                <BotaoComModalConfirmacao
                    titulo={"Confirmação"}
                    texto={"Você está prestes a excluir esse documento, você tem certeza que deseja fazer isso? Essa ação é irreversível!"}
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    onContinue={excluir}
                    onContinueLoads={true}
                />
            </>
        )   
    }

    return (
        <div className="d-flex flex-row align-items-center">
            <ButtonVerMulta docData={undefined} />
            <ButtonDownloadMulta docData={docData} />
            <ButtonEditarDocumento docData={docData} />
            <ButtonExcluir enabled={true} docData={docData} reload={reload} />
        </div>
    )
}

const TabelaDeMultas = () =>
{
    
    const title = "Tabela de multas" 
    const headers = [
        { varName: "numDoc", name: "Nº Multa", sortable: true },
        { varName: "anoDoc", name: "Ano Multa", sortable: true },
        { varName: "createdAt", name: "Data de Criação", sortable: true },
        { varName: "modifiedAt", name: "Data de Modificação", sortable: true },
        { varName: "actions", name: "Ações", sortable: false }
    ]

    const [multas, setMultas] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function fetchMultas()
        {
            const multas = await PegarTodasMultas()
            setMultas(multas)
            
        }
        if (loading)
        {
            fetchMultas()
            setLoading(false)
        }
    }, [loading])

    const elementsWithAction = multas?.map(
        element => ({...element, actions: <ButtonsMulta docData={element} reload={() => {setLoading(true)}} /> })) ?? []

    const pagination = {
        currentPage: 1,
        numPages: 1,
        itemsPerPage: 10,
        totalItems: 4
    }
            
    return (
        <TabelaBanco title={title}
                    headers={headers} elements={elementsWithAction}
                    msgNenhumEncontrado={"Nenhuma multa encontrada"}
                    pagination={pagination}
        />
    )
}


export const MinhasMultasScreen = () =>
{
    const navigate = useNavigate()
    if (!userLogado) { navigate(Links.SEM_PERMISSAO) }

    return (
        <div className="container align-items-center bg-white border border-dark rounded-5 mb-3 shadow">
            <TabelaDeMultas />
        </div>
    )
}